import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, SirenActionMixin, html, nothing } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import { bannerStyles } from '../../styles/banner-styles';
import '../../common/bn-banner';

class BinMessageBanner extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.messages = [];
  }

  static get properties() {
    return {
      messages: { type: Array, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles];
  }

  render() {
    return html`${this.messages.map(msg => this._renderMessage(msg))}`;
  }

  _renderMessage(binMessage) {
    const { message, type } = binMessage.properties;

    let icon = '';
    if (type === 'info') {
      icon = 'far fa-comment-alt';
    }

    return html`
      <bn-banner severity="${type}" icon="${icon}">
        ${message}
        ${this._renderActions(binMessage)}
      </bn-banner>
    `;
  }

  _renderActions(binMessage) {
    const deleteAction = binMessage.getAction('delete-bin-message');
    const { type } = binMessage.properties;

    if (!deleteAction) {
      return nothing;
    }

    return html`
      <span slot="actions">
        <button @click="${() => this._deleteMessage(deleteAction)}" class="banner--button--${type}">
          <bn-icon name="far fa-times"></bn-icon>
        </button>
      </span>
    `;
  }

  async _deleteMessage(action) {
    if (!confirm('Delete Bin Message')) {
      return;
    }
    await this.submitAction(action);
    entityStore.invalidateHref(this.href);
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.messages = this.entity?.getSubEntitiesByClass('bin-message') || [];
  }
}

window.customElements.define('bin-message-banner', BinMessageBanner);
